import {IHttpService} from "angular";
import {MarketState} from "../models/SecurityMarketStateRecord";

export class MarketMapService {

    public static readonly id = "marketMapService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {

    }

    public async state(): Promise<MarketState> {
        const url = `/tradefloor/api/market-map`;
        const response = await this.$http.get<MarketState>(url);
        return response.data!;
    }
}
